module.exports = __webpack_public_path__ + "6ed21c4a713afab42e0611549e3532d7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/komikatext/KOMTXT.ttf
// module id = 233
// module chunks = 0